import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import { useRef, useState } from "react";
import adminService from "api/adminService";
import moment from "moment";
import { IAddressBookVerificationNote } from "dto/Admin/IAddressBookVerificationNote";

const NotiBox = ({
  note,
  onClick,
  handleDelete,
}: {
  note: IAddressBookVerificationNote;
  onClick: (
    note: IAddressBookVerificationNote,
    title: string,
    content: string
  ) => void;
  handleDelete: (note: IAddressBookVerificationNote) => void;
}) => {
  const [, setHover] = useState(false);
  const notiBoxRef = useRef(null);

  return (
    <div
      ref={notiBoxRef}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e: any) => {
        onClick(note, note.Title, note.Content);
      }}
      className={styles.box}
    >
      <div className={styles.wrapBox}>
        <div className={styles.data}>
          <div className={styles.title}>
            <div
              dangerouslySetInnerHTML={{
                __html: note.Title,
              }}
              className={styles.left}
            ></div>
            <div className={styles.right}>
              {moment(note.CreationDate).format("DD.MM.YY")}
            </div>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: note.Content,
            }}
            className={styles.description}
          ></div>
        </div>
      </div>
    </div>
  );
};

const NotesModal: FC<Props> = ({ toggle, pack }) => {
  const { data: notesData } =
    adminService.useGetAddressBookVerificationNotes(pack.Id);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.title}>
            Notatki
            <CloseIcon
              className={styles.closeIcon}
              onClick={(e) => {
                toggle(false);
                e.stopPropagation();
              }}
            />
          </div>
          <div className={styles.list}>
            {notesData?.data.map((n) => (
              <NotiBox
                note={n}
                handleDelete={() => {}}
                onClick={() => {}}
              ></NotiBox>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotesModal;
